export default "__VITE_ASSET__DcBvFKmv__"